// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ascq","left":"styles_left__3AePD"};